/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Field_Delivery_NumberInputs */

const en_inbound_field_delivery_number = /** @type {(inputs: Inbound_Field_Delivery_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery number`)
};

/**
* | output |
* | --- |
* | "Delivery number" |
*
* @param {Inbound_Field_Delivery_NumberInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_field_delivery_number = /** @type {((inputs?: Inbound_Field_Delivery_NumberInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Field_Delivery_NumberInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_field_delivery_number(inputs)
});